import { PRICE_REPRESENTATION_MULTIPLIER } from '@/domain/Pricing';
import { type Product } from '@/domain/Product';
import { type PlansItem } from '@/widgets/services/TrackingService.ts';

export function generateEcommerceObject(
  product: Product,
  isDiscoveryOffer: boolean,
  addedByUser?: boolean
): PlansItem | undefined {
  if (!product) return undefined;

  let price;

  if (product.type === 'capsule') {
    price =
      product.pricing?.pricePerCapsule !== undefined
        ? (product.pricing?.pricePerCapsule ?? 0) /
          PRICE_REPRESENTATION_MULTIPLIER
        : product.pricing.price / PRICE_REPRESENTATION_MULTIPLIER;
  } else {
    price = product.pricing.price / PRICE_REPRESENTATION_MULTIPLIER;
  }

  const output = {
    item_id: product.nessoft?.internationalId,
    item_name: product.name,
    item_brand: 'nespresso',
    item_category: product.type,
    item_category2: product.technologies[0],
    item_category3: product.nessoft?.category,
    item_category4: product.bundle ? ('bundle' as const) : ('single' as const),
    price,
    quantity: product.bundle ? 1 : product.unitQuantity,
    affiliation: 'nespresso online store',

    item_market_id: product.nessoft?.legacyId,
    item_market_name: product.name,
    item_technology: product.technologies[0],
    item_range: product.nessoft?.category,
    item_type: product.bundle ? 'bundle' : 'single',

    item_machine_shade: product.color?.name,
    item_avg_rating: product.rating?.ratingAverage,
    item_number_of_reviews: product.rating?.reviewCount,
    item_in_stock: product.inStock ? 'in stock' : 'out of stock',
    item_discovery_offer: isDiscoveryOffer ? 'true' : 'false',
    item_ecotax_applicable: product.displayEcoTax ? 'true' : 'false',
    item_added_by_user:
      addedByUser !== undefined ? String(addedByUser) : undefined
  } satisfies PlansItem;

  if (output.item_avg_rating === undefined) delete output.item_avg_rating;
  if (output.item_machine_shade === undefined) delete output.item_machine_shade;
  if (output.item_number_of_reviews === undefined)
    delete output.item_number_of_reviews;

  return output;
}
